import axios from 'axios'
import api from '@/services/api'

export default {
    async fetchBank (data) {
      return await axios.post(api.baseUrl + 'ledgerfilter', data)
    },

    async fetchRemember() {
      let rem= await axios.get(api.baseUrl + 'lastused')
      rem = await rem.data
      return rem
    },
    async saveRemember( data) {
      return await axios.post(api.baseUrl + 'lastused', data)
    }
}